"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.view.title': 'Onboarding de Empleado',
    'onboarding.view.meet': 'Conoce a',
    'onboarding.view.new_employee': 'Tu Nuevo Empleado IA',
    'onboarding.view.description.1': 'Con',
    'onboarding.view.description.2': 'crear y publicar contenido es pan comido.',
    'onboarding.view.description.3': 'En solo unos minutos,',
    'onboarding.view.description.4': 'crea una estrategia de contenido y todo el contenido para los próximos meses.',
    'onboarding.view.has_info': 'tiene la siguiente información:',
    'onboarding.view.step': 'Paso',
    'onboarding.view.step1_info': 'Nombre, Edad, Género, Voz, Foto',
    'onboarding.view.knowledge': 'Conocimiento',
    'onboarding.view.learning_description': 'aprenderá todo sobre su empresa escaneando su sitio web, redes sociales y otra información proporcionada.',
    'onboarding.view.learning_description2': '',
    'onboarding.view.talk_with': 'Hablar con',
};
